import { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";

import { GamecardDetailView } from "./component";
import { Product } from "../../../../components/Reusable/type";
import { fetchGamecardPlans } from "../../../../features/auth/store/gamecardPlanSlice";
import { AppDispatch, RootState } from "../../../../redux/store";
import Gamecard from "./Gamecard";
import { fetchGamecardCategories } from "../../../../features/auth/store/gamecardCategorySlice";

const GamecardRouter: React.FC = () => {
  const dispatch = useDispatch<AppDispatch>();
  const [statusFilter, setStatusFilter] = useState<string>("");
  const [selectedGamecardPlan, setSelectedGamecardPlan] =
    useState<Product | null>(null);
  const [showDetailView, setShowDetailView] = useState<boolean>(false);
  const [searchTerm, setSearchTerm] = useState<string>("");

  const { gamecardPlans, loading, error } = useSelector(
    (state: RootState) => state.gamecardPlans,
  );
  const { gamecardCategories } = useSelector(
    (state: RootState) => state.gamecardCategories,
  );

  const isMounted = useRef(false);

  useEffect(() => {
    if (gamecardCategories.length == 0) {
      dispatch(fetchGamecardCategories({ perPage: 40 }));
    }
  }, []);

  useEffect(() => {
    if (!isMounted.current) {
      isMounted.current = true;
      dispatch(fetchGamecardPlans({}));
      return;
    }
    const handler = setTimeout(() => {
      const filters: Record<string, any> = {};

      if (statusFilter) filters.status = statusFilter;
      if (searchTerm.trim()) filters.search = searchTerm.trim();
      dispatch(fetchGamecardPlans(filters));
    }, 350);

    return () => clearTimeout(handler);
  }, [dispatch, statusFilter, searchTerm]);

  // Transform DataPlan to Product - ensuring all required fields are present

  const handleGamecardPlanClick = (dataPlan: Product) => {
    setSelectedGamecardPlan(dataPlan);
    setShowDetailView(true);
  };

  const handleBackToList = () => {
    setShowDetailView(false);
    setSelectedGamecardPlan(null);
  };

  if (showDetailView && selectedGamecardPlan) {
    return (
      <GamecardDetailView
        gamecardPlan={{
          ...selectedGamecardPlan,
        }}
        onBack={handleBackToList}
      />
    );
  }

  return (
    <Gamecard
      gamecardPlans={gamecardPlans || []}
      loading={loading}
      error={error}
      statusFilter={statusFilter}
      setStatusFilter={setStatusFilter}
      onGamecardPlanClick={handleGamecardPlanClick}
      searchTerm={searchTerm}
      setSearchTerm={setSearchTerm}
    />
  );
};

export default GamecardRouter;
